import { message } from '@tencent/met-ui';
import { atou, wemeetBeaconReport } from '@tencent/web-base';

interface MeetingCountdownParams {
  meeting_countdown_push: {
    '@xmlns': string;
    meeting_id: string;
    countdown_hint: {
      action_list: [
        action_item: {
          action_data: string;
          action_type: string;
          text: string;
          visible: string;
        },
      ];
      content_text: string;
    };
    countdown_dialog: {
      action_list: [
        action_item: {
          action_data: string;
          action_type: string;
          text: string;
          visible: string;
        },
      ];
      content_text: string;
    };
    limit_end_time: string;
    reason_type: string;
    remaining_seconds: string;
  };
}

export const handleMeetingCountdown = (data: MeetingCountdownParams, isCreator: boolean) => {
  console.log('handleMeetingCountdown', data);
  const text = atou(data.meeting_countdown_push?.countdown_hint?.content_text);
  const text2 = atou(data.meeting_countdown_push?.countdown_dialog?.content_text);
  if (text && data.meeting_countdown_push.reason_type === '1') {
    message.info({
      content: text,
      showClose: true,
      duration: 0,
    });
  }

  if (text2 && data.meeting_countdown_push.reason_type === '2') {
    wemeetBeaconReport('e#web_meeting#time_reminder#exposure', {
      is_creator: isCreator ? '1' : '0',
    });
    message.error({
      content: text2,
      showClose: true,
      duration: 0,
    });
  }
};
